export default (name, path) => {
  window.dataLayer.push({
    event: 'Pageview',
    pagePath: path,
    pageTitle: name,
  });
};
